"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinReducers = joinReducers;
exports.joinCollectionReducers = joinCollectionReducers;
exports.joinSyncCollectionReducers = joinSyncCollectionReducers;
exports.joinSyncReducers = joinSyncReducers;
function joinReducers(reducers, defaultState) {
    return function (state = defaultState, action) {
        let currentState = state;
        for (let i = 0; i < reducers.length; i++) {
            currentState = reducers[i](currentState, action);
        }
        return currentState;
    };
}
function joinCollectionReducers(reducers, defaultState) {
    return function (state = defaultState, action) {
        let currentState = state;
        for (let i = 0; i < reducers.length; i++) {
            currentState = reducers[i](currentState, action);
        }
        return currentState;
    };
}
function joinSyncCollectionReducers(reducers, defaultState) {
    return function (state = defaultState, action) {
        let currentState = state;
        for (let i = 0; i < reducers.length; i++) {
            currentState = reducers[i](currentState, action);
        }
        return currentState;
    };
}
function joinSyncReducers(reducers, defaultState) {
    return function (state = defaultState, action) {
        let currentState = state;
        for (let i = 0; i < reducers.length; i++) {
            currentState = reducers[i](currentState, action);
        }
        return currentState;
    };
}
//# sourceMappingURL=joinReducers.js.map